export const SOUND = {
    CUE: new Audio("./sfx/cue.mp3"),
    COLLISION: new Audio("./sfx/collision.mp3"),
    BUMPER: new Audio("./sfx/bumper.mp3"),
    POCKET: new Audio("./sfx/pocket.mp3"),
    WHIP: new Audio("./sfx/whip.mp3"),
    WIN: new Audio("./sfx/win.mp3"),
    LOSE: new Audio("./sfx/lose.mp3"),
};

SOUND.WHIP.volume = 0.3;
